<div class="building-efficiency-wizard" *ngIf="visibility && !isMeterListLoading">
  <section class="header">
    <div class="left-header">
      <span class="title">{{ 'module.shared.buildingEfficiencyWizard.headerText' | translate }}</span>
    </div>
    <div class="right-header">
      <span class="step" *ngIf="!viewResults">{{ currentStep }} / {{ numberOfSteps }}</span>
      <button class="btn btn-primary btn-close" (click)="closeWizard()">
        <img class="x-icon" alt="close-icon" src="../../../../assets/icons/close-icon-white.svg" />
      </button>
    </div>
  </section>

  <section class="body">
    <app-time-period-selection
      *ngIf="currentStep === 1"
      (nextButtonStatus)="getNextButtonState($event)"
      (isPeriodChanged)="isPeriodChanged = $event"
      [savedEAReferenceData]="efficiency"
    >
    </app-time-period-selection>

    <app-electricity-meter-selection *ngIf="currentStep === 2" (nextButtonStatus)="getNextButtonState($event)" [savedEAReferenceData]="efficiency">
    </app-electricity-meter-selection>

    <app-heat-selection *ngIf="currentStep === 3" (nextButtonStatus)="getNextButtonState($event)" [savedEAReferenceData]="efficiency"> </app-heat-selection>

    <app-building-efficiency-results class="building-efficiency-results" *ngIf="currentStep === 4" [isEditable]="!viewResults">
    </app-building-efficiency-results>
  </section>

  <section class="footer">
    <div class="buttons">
      <button
        class="btn btn-outline-primary -border-inverted btn-previous"
        *ngIf="currentStep < numberOfSteps || (currentStep === numberOfSteps && !viewResults)"
        (click)="previous()"
      >
        {{ currentStep === 1 ? 'Abbrechen' : 'Zurück' }}
      </button>
      <button class="btn btn-outline-primary -border-inverted btn-next" *ngIf="currentStep < numberOfSteps" (click)="next()" [disabled]="isDisabled">
        {{ currentStep === numberOfSteps ? 'Auswertung' : 'Weiter' }}
      </button>
      <button class="btn btn-outline-primary btn-save" *ngIf="currentStep === numberOfSteps && !viewResults" (click)="save()" [disabled]="isSaveDisabled">
        {{ 'module.shared.buildingEfficiencyWizard.step4.saveButtonText' | translate }}
      </button>
      <button
        class="btn btn-outline-primary -border-inverted"
        *ngIf="currentStep === numberOfSteps && viewResults"
        (click)="closeResultsPage()"
        [disabled]="isDisabled"
      >
        {{ 'module.shared.buildingEfficiencyWizard.step4.finishButtonText' | translate }}
      </button>
    </div>
  </section>
</div>
